import React from 'react';

import AtomIcon from '../assets/svg/atom-icon.inline.svg';
import ContactUsIcon from '../assets/svg/contact-us.inline.svg';
import DocumentIcon from '../assets/svg/document.inline.svg';
import ElectronicReadingIcon from '../assets/svg/electronic-reading.inline.svg';
import EPRRIcon from '../assets/svg/EPRR.inline.svg';
import FAQIcon from '../assets/svg/FAQ.inline.svg';
import LAROIcon from '../assets/svg/LARO.inline.svg';
import PrototypingIcon from '../assets/svg/prototyping.inline.svg';
import PublicationsIcon from '../assets/svg/publications.inline.svg';
import SubjectGuidesIcon from '../assets/svg/subject-guides.inline.svg';

export const iconMapper = (iconName) => {
  switch (iconName.toLowerCase()) {
    case 'atom':
      return <AtomIcon />;
    case 'contact us':
      return <ContactUsIcon />;
    case 'document':
      return <DocumentIcon />;
    case 'electronic-reading':
      return <ElectronicReadingIcon />;
    case 'eprr':
      return <EPRRIcon />;
    case 'faq':
      return <FAQIcon />;
    case 'laro':
      return <LAROIcon />;
    case 'prototyping':
      return <PrototypingIcon />;
    case 'publications':
      return <PublicationsIcon />;
    case 'subject guides':
      return <SubjectGuidesIcon />;
    default:
      return <AtomIcon />;
  }
};
